import { ComponentElement } from './stores/componentManager';
import Modal from './webcomponents/modal';
import Accordion from './webcomponents/accordion';
import AccordionGroup from './webcomponents/accordion-group';
import Carousel from './webcomponents/carousel';
import Dropdown from './webcomponents/dropdown';
import Split from './webcomponents/split';
import SplitText from './webcomponents/split-text';
import ListingAnchors from './webcomponents/listing-anchors';
import HwCarousel from './webcomponents/hw-carousel';
import Header from './webcomponents/header';

export default async function () {
  customElements.define('c-modal', ComponentElement(Modal, 'Modal'));
  customElements.define('c-carousel', ComponentElement(Carousel, 'Carousel'));
  customElements.define('c-accordion', ComponentElement(Accordion, 'Accordion'));
  customElements.define('c-split', ComponentElement(Split, 'Split'));
  customElements.define('c-dropdown', ComponentElement(Dropdown, 'Dropdown'));
  customElements.define('c-accordion-group', ComponentElement(AccordionGroup, 'AccordionGroup'));
  customElements.define('c-listing-anchors', ComponentElement(ListingAnchors, 'ListingAnchors'));
  customElements.define('c-split-text', ComponentElement(SplitText, 'SplitText'));
  customElements.define('c-hw-carousel', ComponentElement(HwCarousel, 'HwCarousel'));
  customElements.define('c-header', ComponentElement(Header, 'Header'));
}
